import { persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface ICurrentLenderCompany {
  lenderCompanyId: number | null;
  setCurrentLenderCompany: (lenderCompanyId: number) => void;
  clearCurrentLenderCompany: () => void;
}

const initialState: Pick<ICurrentLenderCompany, "lenderCompanyId"> = {
  lenderCompanyId: null,
} as const;

export const useCurrentLenderCompanyStore =
  createWithEqualityFn<ICurrentLenderCompany>()(
    persist<ICurrentLenderCompany>(
      (set) => ({
        ...initialState,
        setCurrentLenderCompany: (lenderCompanyId: number) =>
          set({ lenderCompanyId }),
        clearCurrentLenderCompany: () => set({ lenderCompanyId: null }),
      }),
      {
        name: "current-lender-company",
      },
    ),
    shallow,
  );
